<template>
<div @click="clickGame(item)" class="game row position-relative cursor-pointer">
	<div v-if="item.status=='reserved'" class="reserved-text position-absolute text-uppercase page-title start-50 top-50 w-auto z-1">Rezervat</div>
	<div class="col-12 mb-3" v-if="item.status!='hidden'" :class="{ 'opacity-25': item.status=='reserved' }">
	    <div class="card shadow h-100 p-0 p-md-2 position-relative" :class="'border-left-'+item.condition">
	        <div class="card-body pt-1 pt-md-0 pb-0">
	            <div class="row align-items-center h-100">
	                <div class="cover col-1 mr-2 h-100 d-mobile-none" :style="{ backgroundImage: 'url(\''+item.thumbnail+'\')' }"></div>
	                <div class="col pl-0 pl-md-2 ml-md-1">
	                    <div class="cover bg-md-none pl-5 pl-md-1 ml-n1 ml-md-0" :style="{ backgroundImage: 'linear-gradient(to right, transparent 0%, transparent 6%, #FFFFFF 15%, #FFFFFF 100%), url(\''+item.thumbnail+'\')' }">
	                        <div class="row no-gutters">
	                            <div class="col-4 mr-2">
	                                <div class="shadow-white text-xs font-weight-bold text-uppercase mb-1 d-inline" :class="'text-'+item.condition">{{showCondition(item.condition)}}</div>
	                            </div>
	                            <div v-if="item.type!='other'" class="col text-right">
	                                <span v-if="item.bundle_name" class="text-xs mb-1 text-muted">
	                                	Parte din pachetul <strong :class="'text-'+item.condition">{{ item.bundle_name}}</strong>
	                                	<span v-if="item.bundle_price"> la <strong class="text-black">{{ item.bundle_price }} RON</strong></span>
	                                </span>
	                            </div>
	                        </div>
	                        <div class="row no-gutters mb-1">
	                            <div class="col mr-2">
	                                <span class="h4 mb-0 font-weight-bold text-black-800 fs-mobile-5 shadow-white name">
	                                    {{ item.name }} 
	                                    <span :class="'text-'+item.condition"><i class="h6 fa-solid fa-arrow-up-right-from-square d-mobile-none"></i></span>
	                                </span>
	                                <div class="shadow-white stats text-xs text-md-s">
	                                    În lista <strong :class="'text-'+item.condition">{{ item.list_name }}</strong>
	                                </div>
	                            </div>
	                            <div v-if="item.price" class="col-3 text-right">
	                                <h4 class="text-right fs-mobile-5 fs-md-4 text-black">
	                                    <strong class="">{{item.price}} <span class="fs-mobile-6 fs-md-5 fw-bold">RON</span></strong>
	                                </h4>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	        </div>
	        <div v-if="item.notes" class="row no-gutters mb-1 mt-md-2">
	            <div class="col px-3">
	                <div class="input-group mb-0 text-gray align-left bg-light border px-2 p-0 p-md-2 px-md-3 d-block">
	                    <div class="float-start">
	                        <span class="text-xs text-md-s font-weight-bold mr-1">Notă:</span>
	                    </div>
	                    <span v-if="item.notes" class="text-xs text-md-s">{{item.notes}}</span>
	                    <span v-else>&nbsp;</span>
	                </div>
	            </div>
	        </div>
	    </div>
	</div>
</div>
</template>
<script>
    import Vue from "vue";
    import HelperItemMixin from "../mixins/HelperItemMixin";
    import Popper from 'vue-popperjs';
    import VTooltip from 'v-tooltip'

    Vue.use(VTooltip);

    export default {
        name: "SearchItem",
        components: { 'popper': Popper },
        mixins: [HelperItemMixin],
        props: ['item', 'index', 'parentId'],
        data() {
            return {}
        },
        mounted() {},
        methods: {
            clickGame: function(item) { 
            	window.open('/list/'+item.list_id+'#'+item.id, "_blank");
            },
        }
    };
</script>